module.exports = __WEBPACK_EXTERNAL_MODULE_107__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"react","commonjs2":"react","root":"React","amd":"react"}
// module id = 107
// module chunks = 0